import { createAction } from '@reduxjs/toolkit';
import { SendCommandResponse } from '~/api/robotic-mower-api';
import type { RoboticMowerSocketMessage } from '~/components/views/WebSocketReceiver/types';
import type RoboticMowerSocketReasonConstants from '~/constants/robotic-mower-socket-reason-constants';
import type RoboticMowerCommand from '~/ducks/robotic-mower-command/robotic-mower-command';
import RoboticMowerSetting from '~/ducks/robotic-mower-command/robotic-mower-setting';
import * as roboticMowerLoadingStateActions from '~/ducks/robotic-mower-loading-states/reducer';
import { createRequestAction } from '~/utils/create-action/create-action';
import getCurrentDirname from '~/utils/get-current-dirname/get-current-dirname';
import type RoboticMowerCommandActionType from './robotic-mower-command-action-type';

const prefix = getCurrentDirname(__dirname);

export const parkRoboticMowersWithCommand = createRequestAction<{
  assetIds: AssetId[];
  commandActionType: RoboticMowerCommandActionType;
  commandTimerInMinutes?: number;
  missionId: number | null;
}>(`${prefix}/PARK_ROBOTIC_MOWERS_WITH_COMMAND`);

export const startRoboticMowersWithCommand = createRequestAction<{
  assetIds: AssetId[];
  commandActionType: RoboticMowerCommandActionType;
  commandTimerInMinutes?: number;
  missionId: number | null;
}>(`${prefix}/START_ROBOTIC_MOWERS_WITH_COMMAND`);

export const socketReceiveRoboticMower = createAction<{
  reason: RoboticMowerSocketReasonConstants;
  roboticMower: RoboticMowerSocketMessage['object'];
}>(`${prefix}/SOCKET_RECEIVE_ROBOTIC_MOWER`);

export const updateAssetStatuses = createAction<{
  response: SendCommandResponse;
  command: RoboticMowerCommand | RoboticMowerSetting;
  loadingState: boolean;
  successAction: (arg: {
    loadingState: boolean;
    assetId: AssetId;
    missionId: number | null;
  }) => any;
}>(`${prefix}/UPDATE_ASSET_STATUSES`);

export const updatePatternLoadingState = (response: SendCommandResponse, loadingState: boolean) =>
  updateAssetStatuses({
    response,
    loadingState,
    command: RoboticMowerSetting.PATTERN,
    successAction: roboticMowerLoadingStateActions.setIsSettingPattern,
  });

export const updateMissionLoadingState = (response: SendCommandResponse, loadingState: boolean) =>
  updateAssetStatuses({
    response,
    loadingState,
    command: RoboticMowerSetting.MISSION_STATUS,
    successAction: roboticMowerLoadingStateActions.setIsSettingMissionStatus,
  });
